import { Loader2 } from 'lucide-react';
import { Suspense } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { Input } from '@/components/ui/input';
import { UnitSelect } from '@/components/ui/unit-select';
import { MeasurementSystem, UnitType } from '@/types';

interface QuantityInputProps<T extends FieldValues> {
  control: Control<T>;
  quantityName: Path<T>;
  unitName: Path<T>;
  unitType: UnitType[];
  measurementSystem: MeasurementSystem;
  disabled?: boolean;
}

export function QuantityInput<T extends FieldValues>({
  control,
  quantityName,
  unitName,
  unitType,
  disabled,
  measurementSystem,
}: QuantityInputProps<T>) {
  return (
    <div className="relative">
      <Controller
        name={quantityName}
        control={control}
        render={({ field }) => (
          <Input
            type="text"
            placeholder="0"
            {...field}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || /^\d*\.?\d*$/.test(value)) {
                field.onChange(value);
              }
            }}
            className="pr-16"
            disabled={disabled}
          />
        )}
      />
      <div className="absolute right-0 top-0 h-full">
        <Suspense
          fallback={
            <div className="h-full w-16 flex items-center justify-center">
              <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
            </div>
          }
        >
          <UnitSelect
            name={unitName}
            control={control}
            unitType={unitType}
            disabled={disabled}
            measurementSystem={measurementSystem}
          />
        </Suspense>
      </div>
    </div>
  );
}
